<template>
	<div class="set-grading-criteria">
		<!-- 筛选top -->
		<div class="conditionTop clearfix">
			<div class="conditionRight">
				<div class="fc-button-group">
					<button type="button" class="btn btn-info" data-toggle="modal" data-target="#turnOnScoring" @click="openScore" v-if="reviewState == 3">开启专家打分</button>
					<button v-if="reviewState == 3" type="button" class="btn btn-primary ml-1" data-toggle="modal" data-target="#modStandard" @click="openReviewStandard('add')">
						<i class="dripicons-plus mr-1"></i>
						<span>添加评审标准</span>
					</button>
				</div>
			</div>
		</div>

		<table id="pfbz-datatable" class="table table-hover table-bordered table-centered table-proApp">
			<thead>
				<tr>
					<th class="text-center">评审标准名称</th>
					<th class="text-center">评审标准说明</th>
					<th class="text-center">分值</th>
					<th class="text-center">操作</th>
				</tr>
			</thead>

			<tbody v-if="scoreStandardList.length">
				<tr v-for="(item, index) in scoreStandardList" :key="index">
					<td class="text-center">{{ item.name }}</td>
					<td class="text-center">{{ item.note }}</td>
					<td class="text-center">{{ item.score }}</td>
					<td class="text-center">
						<button type="button" class="btn btn-primary btn-rounded ml-1 mr-1" v-if="reviewState == 3" @click="openReviewStandard('edit', index)">修改</button>
						<button type="button" class="btn btn-primary btn-rounded ml-1 mr-1" v-if="reviewState == 3" @click="delReviewStandard(item.id, index)">删除</button>
					</td>
				</tr>

				<tr>
					<th class="text-right" colspan="2">总分：</th>
					<td class="text-center">{{ totalScore }}</td>
					<td class="text-center"></td>
				</tr>
			</tbody>
		</table>

		<div class="text-center">
			<!-- <button type="button" class="btn btn-info" @click="saveScore" style="margin-right: 20px;" v-if="reviewState == 3">保存评分标准</button> -->
			
		</div>
		
		<el-dialog :title="reviewStandardDialogTitle" :visible.sync="reviewStandardDialogVisible" width="50%" :close-on-click-modal="false">
			<el-form :model="reviewStandardForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
				<el-form-item label="评审指标名称" prop="name"><el-input v-model="reviewStandardForm.name"></el-input></el-form-item>
				<el-form-item label="评审指标说明" prop="note"><el-input type="textarea" v-model="reviewStandardForm.note" maxlength="200" show-word-limit></el-input></el-form-item>
				<el-form-item label="分值" prop="score"><el-input v-model="reviewStandardForm.score"></el-input></el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="reviewStandardDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addOrEditReviewStandard">确 定</el-button>
			</span>
		</el-dialog>

		<el-upload
      class="upload-demo"
      action="https://jsonplaceholder.typicode.com/posts/"

      :on-success="handleAvatarSuccess"
			:before-upload="beforeAvatarUpload"
      :file-list="fileList"
      :limit="limit"

			
    >
     评分标准附件： <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
	</div>
</template>

<script>
// import { getScoringList, saveScoring, delScoreStandardById, getReviewBaseInfoById } from '@/api/after/expertReviewSettings.js';
import { getScoringList, getBaseInfoDetail, saveScoring, delScoringById,uploadToLocal,uploadScoringCriteriaAnnex  } from '@/api/after/topicManage.js';
export default {
	watch: {
		scoreStandardList: {
			handler(val) {
				let totalScore = 0;
				if (val.length) {
					val.forEach(item => {
						totalScore += parseFloat(item.score);
					});
					this.totalScore = totalScore;
				}
			},
			immediate: true,
			deep: true
		}
	},
	data() {
		var validateScore = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入分数'));
			} else if (isNaN(+value)) {
				callback(new Error('请输入数字'));
			} else if (value < 1) {
				callback(new Error('分数在1-100之间'));
			} else if (value > 100) {
				callback(new Error('分数在1-100之间'));
			} else {
				callback();
			}
		};
		return {
			reviewStandardDialogVisible: false,
			reviewStandardForm: {
				name: '',
				note: '',
				score: ''
			},
			rules: {
				name: [{ required: true, message: '请输入评审标准评审', trigger: 'blur' }],
				note: [{ required: true, message: '请输入评审标准说明', trigger: 'blur' }],
				score: [{ required: true, validator: validateScore, trigger: 'blur' }]
			},
			scoreStandardList: [],//评分标准列表
			reviewStandardDialogTitle: '添加评审标准',
			curReviewStandardIndex: 0,
			totalScore: 0, //总分数
			reviewState: 0,
			fileList:[],
			limit:1,
			annexId:0,
		};
	},
	created() {
		this.getBaseInfoDetail();
		this.getScoringList();
	},
	methods: {

		handleAvatarSuccess(file, fileList){

		},
    beforeAvatarUpload(file) {
      let fd = new FormData(); //通过form数据格式来传
      fd.append("file", file); //传文件
      //上传头像
      uploadToLocal(fd)
        .then((res) => {
          if (res.code == 200) {
            this.annexId = res.data[0];
						let settingId = this.$route.query.reviewId;
						
						uploadScoringCriteriaAnnex( settingId, this.annexId)
						.then((res) => {
							console.log(res);
							if(200 == res.code){
								this.$message.success('上传成功');
							}else{
								this.$message.error('上传失败');
							}
								
						}).catch((err)=>{

						});
            
          } else {
            this.$message.error("出错了请联系管理员！");
          }
        })
        .catch(() => {});
    },
		// 根据评审ID获取评审基本信息
		async getBaseInfoDetail() {
			const res = await getBaseInfoDetail(this.$route.query.reviewId);
			if (res.code == 200) {
				console.log('评审基本信息', res);
				this.reviewState = res.data.reviewState;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取评分标准列表
		async getScoringList() {
			const res = await getScoringList(this.$route.query.reviewId);
			if (res.code == 200) {
				console.log('获取设置评分标准列表', res.data);
				this.scoreStandardList = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 打开评审标准兑换框
		openReviewStandard(type, index) {
			this.reviewStandardDialogVisible = true;
			if (type == 'add') {
				this.reviewStandardDialogTitle = '添加评审标准';
			} else if (type == 'edit') {
				this.reviewStandardDialogTitle = '修改评审标准';
				this.curReviewStandardIndex = index;
				this.reviewStandardForm = JSON.parse(JSON.stringify(this.scoreStandardList[index]));
			}
		},
		// 添加或者编辑评审标准
		addOrEditReviewStandard() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					if (this.reviewStandardDialogTitle == '添加评审标准') {
						console.log('要添加的评审标准数据',this.reviewStandardForm);
						let form = JSON.parse(JSON.stringify(this.reviewStandardForm));
						form.settingId = this.$route.query.reviewId;
						this.scoreStandardList.push(form);
						this.formReset();
						this.reviewStandardDialogVisible = false;
						this.saveScore()
					} else if (this.reviewStandardDialogTitle == '修改评审标准') {
						console.log('要修改的评审标准数据',this.reviewStandardForm);
						this.scoreStandardList[this.curReviewStandardIndex] = JSON.parse(JSON.stringify(this.reviewStandardForm));
						// 修改时watch没有更新，所以添加此段代码
						let totalScore = 0;
						this.scoreStandardList.forEach(item => {
							totalScore += parseFloat(item.score);
						});
						this.totalScore = totalScore;
						this.reviewStandardDialogVisible = false;
						console.log(12313465544);
						this.formReset();
					}
					console.log('修改后的列表', this.scoreStandardList);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 删除评审标准
		async delReviewStandard(id, index) {
			if (id) {
				const res = await delScoringById(id);
				if (res.code == 200) {
					this.$message.success('删除成功！');
					await this.getScoringList();
				} else {
					this.$message.error(res.data);
				}
			} else {
				this.scoreStandardList.splice(index, 1);
			}
		},
		// 保存评审打分标准
		async saveScore() {
			let data = JSON.parse(JSON.stringify(this.scoreStandardList));
			// 判断总分是否在0-100之间
			if (data.length) {
				let totalScore = 0
				data.forEach(item=>{
					totalScore += +item.score
				})
				if (totalScore>100) {
					this.$message.error('总分在0-100之间！')
					this.scoreStandardList.splice(-1,1)
					return
				}
				if (totalScore<0) {
					this.$message.error('总分在0-100之间！')
					this.scoreStandardList.splice(-1,1)
					return 
				}
			}
			console.log('要保存的评审打分标准',data);
			let params = {
				criteria: data,
				type: 0
			}
			await this.saveScoring(params);
			await this.getScoringList();
		},
		// 开启打分
		openScore() {
			this.$confirm('进入后评审设置信息不允许修改，确定要进入专家评分阶段吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					let data = JSON.parse(JSON.stringify(this.scoreStandardList));
					let params = {
						criteria: data,
						type: 1
					};
					console.log('要保存的评分标准数据',params);
					await this.saveScoring(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
		},
		// 保存评分标准或者开启打分
		async saveScoring(data) {
			if (this.scoreStandardList.length === 0) {
				this.$message.error('请添加评分标准！');
				return;
			}
			if (this.totalScore > 100) {
				this.$message.error('总分数不能超过100！');
				return;
			}
			if (this.totalScore < 0) {
				this.$message.error('总分数不能小于0！');
				return;
			}
			const res = await saveScoring(data);
			console.log('保存评分标准响应',res);
			if (res.code == 200) {
				this.$message({
					type: 'success',
					message: '保存成功!',
					duration:1000,
				});
				if (data.type==1) {
					this.$emit('finish');
				}
			} else {
				this.$message.error(res.data);
			}
		},
		formReset() {
			this.reviewStandardForm = {
				name: '',
				note: '',
				score: ''
			};
		}
	}
};
</script>

<style scoped></style>
